import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_MICROSITES = "SET_IS_FETCHING_MICROSITES";
export const SET_MICROSITES = "SET_MICROSITES";
export const SET_CURRENT_MICROSITE = "SET_CURRENT_MICROSITE";
export const SET_IS_ADDING_MICROSITE = "SET_IS_ADDING_MICROSITE";
export const SET_IS_FETCHING_MICROSITE = "SET_IS_FETCHING_MICROSITE";
export const SET_IS_EDITING_MICROSITE = "SET_IS_EDITING_MICROSITE";
export const SET_CURRENT_PAGES = "SET_CURRENT_PAGES";

const mutations = {
  [SET_IS_FETCHING_MICROSITES]: setStoreValue("isFetchingMicrosites"),
  [SET_MICROSITES]: setStoreValue("microsites"),
  [SET_IS_ADDING_MICROSITE]: setStoreValue("isAddingMicrosite"),
  [SET_CURRENT_MICROSITE]: setStoreValue("currentMicrosite"),
  [SET_IS_FETCHING_MICROSITE]: setStoreValue("isFetchingMicrosite"),
  [SET_IS_EDITING_MICROSITE]: setStoreValue("isEditingMicrosite"),
  [SET_CURRENT_PAGES]: setStoreValue("currentPages")
};

const state = {
  microsites: [],
  isFetchingMicrosites: false,
  isAddingMicrosite: false,
  currentMicrosite: {},
  isFetchingMicrosite: false,
  isEditingMicrosite: false,
  currentPages: []
};

export { mutations, state };
